import script from "./edit-task-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./edit-task-modal.vue?vue&type=script&setup=true&lang=ts"

import "./edit-task-modal.vue?vue&type=style&index=0&id=c680f6e0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c680f6e0"]])

export default __exports__